<template>
  <v-app id="app" style="background:white">
    <v-card tile v-if="Initialised">
      <v-navigation-drawer
        app
        :clipped="$vuetify.breakpoint.lgAndUp"
        color="#ffffff00"
        floating
        class="elevation-0"
        right
        width ="350"
      >
        <Drawer color="#ffffff00" @close="toggle" align="right" :mask="false" :closeable="false">
          <div v-if="open">
          <v-btn class="mt-6" color="error" fab absolute top right x-small outlined @click="toggle"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar class="mt-0" dense flat color="#ffffff00">
            <v-toolbar-title class="white--text title font-weight-bold mb-0">Pending Confirmations</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-btn
            width="300" dark
            class="text-left"
            block color="#ffffff00" depressed
            v-show="Notification[1] !== 0" v-for="Notification in NotificationsList" :key="Notification"
            @click="emit(Notification[0])"
          >
            <v-icon color="grey" left>mdi-alert-circle-check-outline</v-icon>
            <span class="text-capitalize">{{Notification[0]}}</span>
            <v-spacer/>
            <v-badge color="error" :content="Notification[1]"></v-badge>
          </v-btn>
          </div>
        </Drawer>
        <v-card
          border="left"
          class="mx-auto"
          color="#ffffff00"
          light
          max-width="400"
          elevation="0"
        >
          <v-alert
            class="py-4 my-2 mt-4 mx-3"
            icon="mdi-account"
            outlined text prominent
            type="info"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-on="on" v-bind="attrs" text small block>{{ currentUser.FullName }} <v-icon color="#81DBF6">mdi-chevron-down</v-icon></v-btn>
              </template>

              <v-list dense>
                <v-list-item @click="ChangePassword()">
                  <v-dialog persistent v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="grey--text subtitle-2 font-weight-normal">Change Password</span>
                    </template>
                    <div>
                      <ChangePassword></ChangePassword>
                    </div>
                  </v-dialog>
                </v-list-item>

                <v-list-item href @click.prevent="logOut">
                  <span  v-on="on" class="grey--text subtitle-2 font-weight-normal">Logout</span>
                </v-list-item>
              </v-list>
            </v-menu>

            <div class="my-0 text-center">
              <v-chip color="#2A353D" class="ma-1 white--text" small v-for="role in currentUser.roles.map(r => r.role_name.map(r => r.RoleCode)[0])" :key="role">{{role}}</v-chip>
            </div>
          </v-alert>

          <v-sheet
            class="py-4 mx-3 mb-0 mt-4"
            color="#2A353D"
            elevation="0"
          >
            <div class="mx-3">
              <span class="white--text overline font-weight-normal mt-2 mr-6">System Date: </span>
              <v-chip outlined color="#81DBF6" small>{{ currentSystemDate.DayDate | moment("DD MMM YYYY") }}</v-chip>
            </div>
          </v-sheet>
          <v-date-picker
            width="325"
            class="pa-0 my-0 mx-3"
            color="#2A353D"
            v-model="currentSystemDate.DayDate"
            readonly no-title
          ></v-date-picker>
        </v-card>

        <template v-slot:append>
          <v-sheet
            class="py-3 mx-3"
            color="#2A353D"
            elevation="0"
          >
            <div class="mx-3 mb-5">
              <span class="white--text overline font-weight-normal mt-2 mr-6">Session Token:</span>
              <v-chip outlined color="#81DBF6" small>Active</v-chip>
            </div>

            <div class="mx-3">
              <span class="white--text overline font-weight-normal">Session Timeout</span>
              <v-progress-linear
                rounded
                class="mb-5"
                v-model="session_timeout"
                color="red"
              ></v-progress-linear>
            </div>

            <div class="mx-3">
              <span class="white--text overline font-weight-normal">Session Expiration</span>
                <v-progress-linear
                  rounded
                  class="mb-5"
                  v-model="session_expiration"
                  color="red"
                ></v-progress-linear>
            </div>
          </v-sheet>
        </template>

      </v-navigation-drawer>
    </v-card>

    <SessionExpired v-if="Initialised && app_idle"/>

    <v-app-bar
      v-if="Initialised"
      app
      color="#2A353D"
      elevation="3"
      :clipped-right="$vuetify.breakpoint.lgAndUp"
    >
    <v-row class="px-4 py-2 my-0" style="border-bottom-style: solid; border-color: #81DBF6; border-width: 3px">
      <v-img
        src="./assets/image003.png"
        max-width="50"
        >
      </v-img>

      <NavigationMenu class="mt-2 pb-0"></NavigationMenu>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ml-5 mt-2 py-0" color="#81DBF6">
              mdi-email-outline
            </v-icon>
          </template><span>Mail</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-badge
              class="mt-4"
              color="error"
              :content="Notifications"
              :value="Notifications"
              overlap
            >
              <v-icon v-on="on" @click="toggle" class="ml-5 my-0 py-0" color="#81DBF6">
                mdi-shield-check-outline
              </v-icon>
            </v-badge>
          </template><span>pending confirmations</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-5 mt-2 mb-0 py-0" color="#81DBF6">
              mdi-help-circle-outline
            </v-icon>
          </template><span>Help</span>
        </v-tooltip>
    </v-row>

      <!-- <template color="blue" v-slot:extension>
        <v-row class="mb-3 pl-9" style="border-bottom-style: solid; border-color: #81DBF6; border-width: 3px">
          <v-col  cols="9">
            
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </template> -->
    </v-app-bar>

    <v-content class="main-content" style="width: 1000">
      <v-container fluid mt-2 style="width:100%">
        <!-- <v-sheet
          style="background: #EEF2F4"
          class="fill-height d-flex justify-space-around"
        >
          <v-overlay opacity="0">
            <v-card style="max-width: 350px" color="#ffffff00" elevation="0" class="mt-0">
              <div align="center" justify="center">
                <v-progress-circular
                  :size="300"
                  :width="8"
                  indeterminate
                  color="#00448D"
                >
                  <v-img
                    src="./assets/eFund-small.png"
                    height="200"
                    contain
                    >
                  </v-img>
                </v-progress-circular>
              </div>
            </v-card>
          </v-overlay>
        </v-sheet> -->
        <router-view v-if="Initialised || publicPages.includes(currentRoute)"/>
        <v-overlay v-else color="#2A353D" :opacity="1">
          <v-progress-circular
            color="#81DBF6"
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
import ChangePassword from './components/ChangePassword';
import SessionExpired from './components/SessionExpired';
import NavigationMenu from './components/NavigationMenu';
import Drawer from "vue-simple-drawer";
import {mapGetters, mapActions} from "vuex";

export default {
  name: 'App',

  components: {
    ChangePassword,
    SessionExpired,
    NavigationMenu,
    Drawer,
  },

  data () {
  return {
      dialog: false,
      submitted: false,
      Initialised: false,
      timerId: {},
      interval: {},
      timeout_interval: {},
      session_expiration: 0,
      session_timeout: 0,
      winheight: 0,
      app_idle: false,
      publicPages: [
        'login',
        'userConfirmed',
        'reset_password',
        'logintoken',
        'forgot_password'
      ],
      pageSizes: [
        'xs',
        'sm',
        'md'
      ],
      bar1: 60,
      bar2: 40,
      bar3: 80,
      bar4: 50,
      value: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240,
      ],
      open: false,
      lists: [{id: 1, name: "test1"},{id: 2, name: "test2"}] 
    }
  },

  watch: {
    isIdle: function(newValue){
      if(newValue == true){
        this.timeout_interval = setInterval(() => {
          if (this.session_timeout == 100) {
            this.app_idle = true
          }
          this.session_timeout += 1
        }, 9000)
      } else {
        clearInterval(this.timeout_interval);
        this.timeout_interval = {}
        this.session_timeout = 0
      }
    },
    currentUser: function(newValue){
      if(newValue == null){
        this.Initialised = false
      }
    }
  },

  computed: {
		isIdle() {
			return this.$store.state.idleVue.isIdle;
    },
    ...mapGetters([
      ////////////////////////////////////////////////////////////////////////////////MAINTENANCE/////////////////////////////////////////////////////////////////////////////////
      // "allActivations",
      "currentSystemDate",
      "identity",
      "unconfirmedActivations",
      // "allBankAccountTypes",
      "unconfirmedBankAccountTypes",
      // "allOffices",
      "unconfirmedOffices",
      // "allBanks",
      "unconfirmedBanks",
      "unconfirmedBankBranches",
      // "allBondInvestmentTypes",
      "unconfirmedBondInvestmentTypes",
      // "allCallAccountTypes",
      "unconfirmedCallAccountTypes",
      // "allCountries",
      "unconfirmedCountries",
      // "allCities",
      "unconfirmedCities",
      // "allClientTypes",
      "unconfirmedClientTypes",
      // "allCurrencies",
      "unconfirmedCurrencies",
      // "allDealerGroups",
      "unconfirmedDealerGroups",
      // "allDeliveryMethods",
      "unconfirmedDeliveryMethods",
      // "allDepositMethods",
      "unconfirmedDepositMethods",
      // "allFinancialYears",
      "unconfirmedFinancialYears",
      // "allFrequencies",
      "unconfirmedFrequencies",
      // "allHolidays",
      "unconfirmedHolidays",
      // "allIdentityTypes",
      "unconfirmedIdentityTypes",
      // "allOverrideReasons",
      "unconfirmedOverrideReasons",
      // "allPropertyTypes",
      "unconfirmedPropertyTypes",
      // "allRejectionReasons",
      "unconfirmedRejectionReasons",
      // "allSectors",
      "unconfirmedSectors",
      // "allAccountStatuses",
      "unconfirmedAccountStatuses",
      // "allCustodianStatuses",
      "unconfirmedCustodianStatuses",
      // "allPropertyStatuses",
      "unconfirmedPropertyStatuses",
      // "allExchangePairs",
      "unconfirmedExchangePairs",
      // "allTitles",
      "unconfirmedTitles",
      // "allTransactionCodes",
      "unconfirmedTransactionCodes",
      // "allPermissions",
      "unconfirmedPermissions",
      ////////////////////////////////////////////////////////////////////////////////SECURITY///////////////////////////////////////////////////////////////////////////////////////
      "unconfirmedUsers",
      "unconfirmedRoles",
      ////////////////////////////////////////////////////////////////////////////////ADMINISTRATION/////////////////////////////////////////////////////////////////////////////////
      "unconfirmedInstrumentTypes",
      "unconfirmedClients",
      "unconfirmedClientAccounts",
      "unconfirmedClientContacts",
      "unconfirmedClientSignatories",
      "unconfirmedCounterpartyLimits",
      "unconfirmedDealerLimits",
      "unconfirmedTaxRates",
      "unconfirmedTaxes",
      "unconfirmedMMRates",
      "unconfirmedFees",
      "unconfirmedTransactionCharges",
      "unconfirmedPeriods",
      "unconfirmedEventMappings",
      "unconfirmedCustodians",
      "unconfirmedTransactionchargerates",
      "unconfirmedEquities",
      "unconfirmedUlEquities",
      "unconfirmedBonds",
      "unconfirmedProperties",
      "unconfirmedPropertyValues",
      "unconfirmedCounterparties",
      "unconfirmedDailyExchanges",
      "unconfirmedDealers",
      "unconfirmedUnitTrustFunds",
      "unconfirmedUnitTrustRedemptions",
      "unconfirmedUnitTrustSubscriptions",
      "unconfirmedUnitDistributions",
      ////////////////////////////////////////////////////////////////////////////////TRANSACTIONS///////////////////////////////////////////////////////////////////////////////////
      "unconfirmedDeposits",
      "unconfirmedWithdrawals",
      "unconfirmedCreditAdjustments",
      "unconfirmedDebitAdjustments",
      "unconfirmedIncomes",
      ////////////////////////////////////////////////////////////////////////////////DEALS///////////////////////////////////////////////////////////////////////////////////
      "unconfirmedBondPurchases",
      "unconfirmedEquityPurchases",
      "unconfirmedMMPurchases",
      "unconfirmedPropertyPurchases",
      "unconfirmedBondSales",
      "unconfirmedEquitySales",
      "unconfirmedMMSales",
      "unconfirmedPropertySales",
      "unconfirmedAssetTrasnfersEquity",
      "unconfirmedReversals"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentRoute() {
      return this.$route.name;
    },
    Notifications () {
      return this.unconfirmedActivations[0].length +
      this.unconfirmedBankAccountTypes[0].length +
      this.unconfirmedOffices[0].length +
      this.unconfirmedBanks[0].length +
      this.unconfirmedBankBranches[0].length +
      this.unconfirmedBondInvestmentTypes[0].length +
      this.unconfirmedCallAccountTypes[0].length +
      this.unconfirmedCountries[0].length +
      this.unconfirmedCities[0].length +
      this.unconfirmedClientTypes[0].length +
      this.unconfirmedCurrencies[0].length +
      this.unconfirmedDealerGroups[0].length +
      this.unconfirmedDeliveryMethods[0].length +
      this.unconfirmedDepositMethods[0].length +
      this.unconfirmedFinancialYears[0].length +
      this.unconfirmedFrequencies[0].length +
      this.unconfirmedHolidays[0].length +
      this.unconfirmedIdentityTypes[0].length +
      this.unconfirmedOverrideReasons[0].length +
      this.unconfirmedPropertyTypes[0].length +
      this.unconfirmedRejectionReasons[0].length +
      this.unconfirmedSectors[0].length +
      this.unconfirmedAccountStatuses[0].length +
      this.unconfirmedCustodianStatuses[0].length +
      this.unconfirmedPropertyStatuses[0].length +
      this.unconfirmedExchangePairs[0].length +
      this.unconfirmedTitles[0].length +
      this.unconfirmedTransactionCodes[0].length +
      this.unconfirmedRoles[0].length +
      this.unconfirmedUsers[0].length +
      this.unconfirmedInstrumentTypes[0].length +
      this.unconfirmedCounterpartyLimits[0].length +
      this.unconfirmedDealerLimits[0].length +
      this.unconfirmedTaxRates[0].length +
      this.unconfirmedTaxes[0].length +
      this.unconfirmedMMRates[0].length +
      this.unconfirmedFees[0].length +
      this.unconfirmedTransactionCharges[0].length +
      this.unconfirmedPeriods[0].length +
      this.unconfirmedDeposits[0].length +
      this.unconfirmedWithdrawals[0].length +
      this.unconfirmedCreditAdjustments[0].length +
      this.unconfirmedDebitAdjustments[0].length +
      this.unconfirmedBondPurchases[0].length +
      this.unconfirmedEquityPurchases[0].length +
      this.unconfirmedMMPurchases[0].length +
      this.unconfirmedPropertyPurchases[0].length +
      this.unconfirmedBondSales[0].length +
      this.unconfirmedEquitySales[0].length +
      this.unconfirmedMMSales[0].length +
      this.unconfirmedPropertySales[0].length +
      this.unconfirmedReversals[0].length +
      this.unconfirmedClients[0].length +
      this.unconfirmedClientAccounts[0].length +
      this.unconfirmedClientSignatories[0].length +
      this.unconfirmedClientContacts[0].length +
      this.unconfirmedAssetTrasnfersEquity[0].length +
      this.unconfirmedCustodians[0].length +
      this.unconfirmedEventMappings[0].length +
      this.unconfirmedTransactionchargerates[0].length +
      this.unconfirmedEquities[0].length +
      this.unconfirmedUlEquities[0].length +
      this.unconfirmedIncomes[0].length +
      this.unconfirmedBonds[0].length +
      this.unconfirmedProperties[0].length +
      this.unconfirmedPropertyValues[0].length +
      this.unconfirmedCounterparties[0].length +
      this.unconfirmedDailyExchanges[0].length +
      this.unconfirmedDealers[0].length +
      this.unconfirmedUnitTrustFunds[0].length +
      this.unconfirmedUnitTrustRedemptions[0].length +
      this.unconfirmedUnitTrustSubscriptions[0].length +
      this.unconfirmedUnitDistributions[0].length
    },
    NotificationsList () {
      return [[this.unconfirmedActivations[1].toLocaleString(), this.unconfirmedActivations[0].length],
      [this.unconfirmedBankAccountTypes[1].toLocaleString(), this.unconfirmedBankAccountTypes[0].length],
      [this.unconfirmedOffices[1].toLocaleString(), this.unconfirmedOffices[0].length],
      [this.unconfirmedBanks[1].toLocaleString(), this.unconfirmedBanks[0].length],
      [this.unconfirmedBankBranches[1].toLocaleString(), this.unconfirmedBankBranches[0].length],
      [this.unconfirmedBondInvestmentTypes[1].toLocaleString(), this.unconfirmedBondInvestmentTypes[0].length],
      [this.unconfirmedCallAccountTypes[1].toLocaleString(), this.unconfirmedCallAccountTypes[0].length],
      [this.unconfirmedCountries[1].toLocaleString(), this.unconfirmedCountries[0].length],
      [this.unconfirmedCities[1].toLocaleString(), this.unconfirmedCities[0].length],
      [this.unconfirmedClientTypes[1].toLocaleString(), this.unconfirmedClientTypes[0].length],
      [this.unconfirmedCurrencies[1].toLocaleString(), this.unconfirmedCurrencies[0].length],
      [this.unconfirmedDealerGroups[1].toLocaleString(), this.unconfirmedDealerGroups[0].length],
      [this.unconfirmedDeliveryMethods[1].toLocaleString(), this.unconfirmedDeliveryMethods[0].length],
      [this.unconfirmedDepositMethods[1].toLocaleString(), this.unconfirmedDepositMethods[0].length],
      [this.unconfirmedFinancialYears[1].toLocaleString(), this.unconfirmedFinancialYears[0].length],
      [this.unconfirmedFrequencies[1].toLocaleString(), this.unconfirmedFrequencies[0].length],
      [this.unconfirmedHolidays[1].toLocaleString(), this.unconfirmedHolidays[0].length],
      [this.unconfirmedIdentityTypes[1].toLocaleString(), this.unconfirmedIdentityTypes[0].length],
      [this.unconfirmedOverrideReasons[1].toLocaleString(), this.unconfirmedOverrideReasons[0].length],
      [this.unconfirmedPropertyTypes[1].toLocaleString(), this.unconfirmedPropertyTypes[0].length],
      [this.unconfirmedRejectionReasons[1].toLocaleString(), this.unconfirmedRejectionReasons[0].length],
      [this.unconfirmedSectors[1].toLocaleString(), this.unconfirmedSectors[0].length],
      [this.unconfirmedAccountStatuses[1].toLocaleString(), this.unconfirmedAccountStatuses[0].length],
      [this.unconfirmedCustodianStatuses[1].toLocaleString(), this.unconfirmedCustodianStatuses[0].length],
      [this.unconfirmedPropertyStatuses[1].toLocaleString(), this.unconfirmedPropertyStatuses[0].length],
      [this.unconfirmedExchangePairs[1].toLocaleString(), this.unconfirmedExchangePairs[0].length],
      [this.unconfirmedTitles[1].toLocaleString(), this.unconfirmedTitles[0].length],
      [this.unconfirmedTransactionCodes[1].toLocaleString(), this.unconfirmedTransactionCodes[0].length],
      [this.unconfirmedRoles[1].toLocaleString(), this.unconfirmedRoles[0].length],
      [this.unconfirmedUsers[1].toLocaleString(), this.unconfirmedUsers[0].length],
      [this.unconfirmedInstrumentTypes[1].toLocaleString(), this.unconfirmedInstrumentTypes[0].length],
      [this.unconfirmedCounterpartyLimits[1].toLocaleString(), this.unconfirmedCounterpartyLimits[0].length],
      [this.unconfirmedDealerLimits[1].toLocaleString(), this.unconfirmedDealerLimits[0].length],
      [this.unconfirmedTaxRates[1].toLocaleString(), this.unconfirmedTaxRates[0].length],
      [this.unconfirmedTaxes[1].toLocaleString(), this.unconfirmedTaxes[0].length],
      [this.unconfirmedMMRates[1].toLocaleString(), this.unconfirmedMMRates[0].length],
      [this.unconfirmedFees[1].toLocaleString(), this.unconfirmedFees[0].length],
      [this.unconfirmedTransactionCharges[1].toLocaleString(), this.unconfirmedTransactionCharges[0].length],
      [this.unconfirmedPeriods[1].toLocaleString(), this.unconfirmedPeriods[0].length],
      [this.unconfirmedDeposits[1].toLocaleString(), this.unconfirmedDeposits[0].length],
      [this.unconfirmedWithdrawals[1].toLocaleString(), this.unconfirmedWithdrawals[0].length],
      [this.unconfirmedCreditAdjustments[1].toLocaleString(), this.unconfirmedCreditAdjustments[0].length],
      [this.unconfirmedDebitAdjustments[1].toLocaleString(), this.unconfirmedDebitAdjustments[0].length],
      [this.unconfirmedBondPurchases[1].toLocaleString(), this.unconfirmedBondPurchases[0].length],
      [this.unconfirmedEquityPurchases[1].toLocaleString(), this.unconfirmedEquityPurchases[0].length],
      [this.unconfirmedMMPurchases[1].toLocaleString(), this.unconfirmedMMPurchases[0].length],
      [this.unconfirmedPropertyPurchases[1].toLocaleString(), this.unconfirmedPropertyPurchases[0].length],
      [this.unconfirmedBondSales[1].toLocaleString(), this.unconfirmedBondSales[0].length],
      [this.unconfirmedEquitySales[1].toLocaleString(), this.unconfirmedEquitySales[0].length],
      [this.unconfirmedMMSales[1].toLocaleString(), this.unconfirmedMMSales[0].length],
      [this.unconfirmedPropertySales[1].toLocaleString(), this.unconfirmedPropertySales[0].length],
      [this.unconfirmedReversals[1].toLocaleString(), this.unconfirmedReversals[0].length],
      [this.unconfirmedClients[1].toLocaleString(), this.unconfirmedClients[0].length],
      [this.unconfirmedClientAccounts[1].toLocaleString(), this.unconfirmedClientAccounts[0].length],
      [this.unconfirmedClientContacts[1].toLocaleString(), this.unconfirmedClientContacts[0].length],
      [this.unconfirmedClientSignatories[1].toLocaleString(), this.unconfirmedClientSignatories[0].length],
      [this.unconfirmedAssetTrasnfersEquity[1].toLocaleString(), this.unconfirmedAssetTrasnfersEquity[0].length],
      [this.unconfirmedCustodians[1].toLocaleString(), this.unconfirmedCustodians[0].length],
      [this.unconfirmedEventMappings[1].toLocaleString(), this.unconfirmedEventMappings[0].length],
      [this.unconfirmedTransactionchargerates[1].toLocaleString(), this.unconfirmedTransactionchargerates[0].length],
      [this.unconfirmedEquities[1].toLocaleString(), this.unconfirmedEquities[0].length],
      [this.unconfirmedUlEquities[1].toLocaleString(), this.unconfirmedUlEquities[0].length],
      [this.unconfirmedIncomes[1].toLocaleString(), this.unconfirmedIncomes[0].length],
      [this.unconfirmedBonds[1].toLocaleString(), this.unconfirmedBonds[0].length],
      [this.unconfirmedProperties[1].toLocaleString(), this.unconfirmedProperties[0].length],
      [this.unconfirmedPropertyValues[1].toLocaleString(), this.unconfirmedPropertyValues[0].length],
      [this.unconfirmedCounterparties[1].toLocaleString(), this.unconfirmedCounterparties[0].length],
      [this.unconfirmedDailyExchanges[1].toLocaleString(), this.unconfirmedDailyExchanges[0].length],
      [this.unconfirmedDealers[1].toLocaleString(), this.unconfirmedDealers[0].length],
      [this.unconfirmedUnitTrustFunds[1].toLocaleString(), this.unconfirmedUnitTrustFunds[0].length],
      [this.unconfirmedUnitTrustRedemptions[1].toLocaleString(), this.unconfirmedUnitTrustRedemptions[0].length],
      [this.unconfirmedUnitTrustSubscriptions[1].toLocaleString(), this.unconfirmedUnitTrustSubscriptions[0].length],
      [this.unconfirmedUnitDistributions[1].toLocaleString(), this.unconfirmedUnitDistributions[0].length]
    ]},
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          return this.currentUser.roles[i].role_name.map(r => r.RoleCode).toLocaleString() == "ADMIN";
        }
      }
      return false;
    },
  },

  methods: {
    ...mapActions([
      "getAllImages",
      "getAllActivations",
      "getAllBankAccountTypes",
      "getAllBankBranches",
      "getAllFundAccountTypes",
      "getAllOffices",
      "getAllBanks",
      "getAllBondInvestmentTypes",
      "getAllCallAccountTypes",
      "getAllCountries",
      "getAllCities",
      "getAllClientTypes",
      "getAllCurrencies",
      "getAllDealerGroups",
      "getAllDeliveryMethods",
      "getAllDepositMethods",
      "getAllFinancialYears",
      "getAllFrequencies",
      "getAllHolidays",
      "getAllIdentityTypes",
      "getAllOverrideReasons",
      "getAllPropertyTypes",
      "getAllRejectionReasons",
      "getAllSectors",
      "getAllAccountStatuses",
      "getAllCustodianStatuses",
      "getAllPropertyStatuses",
      "getAllExchangePairs",
      "getAllTitles",
      "getAllTransactionCodes",
      "getAllPermissions",
      "getAllUsers",
      "getAllRoles",
      "getAllInvalidPasswords",
      "getSettings",
      "getAllInstrumentTypes",
      "getAllCounterpartyLimits",
      "getAllCounterparties",
      "getAllDealerLimits",
      "getAllTaxRates",
      "getAllTaxes",
      "getAllFees",
      "getAllClients",
      "getAllClientAccounts",
      "getAllClientContacts",
      "getAllClientSignatories",
      "getAllApplicationModules",
      "getAllTransactionCharges",
      "getAllPeriods",
      "getAllApplicationDefaults",
      "getAllBackdatingLimitPeriods",
      "getAllUnitsRounding",
      "getAllTransactions",
      "getAllPurchases",
      "getAllSales",
      "retrieveBonds",
      "retrieveDealers",
      "retrieveCounters",
      "retrieveUnlistedCounters",
      "getAllCustodians",
      "getAllComDocuments",
      "getAllDecDocuments",
      "getAllIndDocuments",
      "getAllParDocuments",
      "getAllPenDocuments",
      "getAllTruDocuments",
      "getIdentity"
    ]),
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    ChangePassword () {
      this.submitted = false
    },
    toggle() {
      this.open = !this.open
    },
    emit(data) {
      this.$root.$emit(data)
    },
    publicContent(){
      if(this.publicPages.includes(this.$route.name)){
        this.$store.dispatch('auth/logout');
      }
    },
    SessionTicker(){
      // this.interval = setInterval(() => {
      //   if (this.session_expiration == 99.936) {
      //     this.$store.dispatch('auth/logout');
      //     this.$router.push('/login');
      //   }
      //   this.session_expiration += 0.0694
      // }, 60000)
    },
    BrowserZoom(){
      if(this.winheight <= 768){
        document.body.style.zoom = 0.9
      }
    }
  },

  // created () {
  //   this.getAllImages();
  //   this.getAllActivations();
  //   this.getAllBankAccountTypes();
  //   this.getAllBankBranches();
  //   this.getAllFundAccountTypes();
  //   this.getAllOffices();
  //   this.getAllBanks();
  //   this.getAllBondInvestmentTypes();
  //   this.getAllCallAccountTypes();
  //   this.getAllCountries();
  //   this.getAllCities();
  //   this.getAllClientTypes();
  //   this.getAllCurrencies();
  //   this.getAllDealerGroups();
  //   this.getAllDeliveryMethods();
  //   this.getAllDepositMethods();
  //   this.getAllFinancialYears();
  //   this.getAllFrequencies();
  //   this.getAllHolidays();
  //   this.getAllIdentityTypes();
  //   this.getAllOverrideReasons();
  //   this.getAllPropertyTypes();
  //   this.getAllRejectionReasons();
  //   this.getAllSectors();
  //   this.getAllAccountStatuses();
  //   this.getAllCustodianStatuses();
  //   this.getAllPropertyStatuses();
  //   this.getAllExchangePairs();
  //   this.getAllTitles();
  //   this.getAllTransactionCodes();
  //   this.getAllPermissions();
  //   this.getAllUsers();
  //   this.getAllRoles();
  //   this.getAllInvalidPasswords();
  //   this.getSettings();
  //   this.getAllInstrumentTypes();
  //   this.getAllCounterpartyLimits();
  //   this.getAllCounterparties();
  //   this.getAllDealerLimits();
  //   this.getAllTaxRates();
  //   this.getAllTaxes();
  //   this.getAllFees();
  //   this.getAllClients();
  //   this.getAllClientAccounts();
  //   this.getAllClientContacts();
  //   this.getAllClientSignatories();
  //   this.getAllApplicationModules();
  //   this.getAllTransactionCharges();
  //   this.getAllPeriods();
  //   this.getAllApplicationDefaults();
  //   this.getAllBackdatingLimitPeriods();
  //   this.getAllUnitsRounding();
  //   this.getAllTransactions();
  //   this.getAllPurchases();
  //   this.getAllSales();
  //   this.retrieveBonds();
  //   this.retrieveDealers();
  //   this.retrieveCounters();
  //   this.retrieveUnlistedCounters();
  //   this.getAllCustodians();
  //   this.getAllComDocuments();
  //   this.getAllDecDocuments();
  //   this.getAllIndDocuments();
  //   this.getAllParDocuments();
  //   this.getAllPenDocuments();
  //   this.getAllTruDocuments();
  //   this.getIdentity();
  // },

  sockets: {
    connect() {
      console.log('socket connected')
    },
    socketres(res) {
      this.$store.commit(`${res.commit}`, res.data)
    },
    socketlogoutres() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
      this.$router.go(0);
    }
  },

  mounted () {
    this.$root.$on("closeChangePassword", () => {
      this.dialog = false;
    });
    this.$root.$on("Initialised", () => {
      this.Initialised = true;
      this.SessionTicker()
    });
    this.winheight = window.screen.height;
    this.BrowserZoom();
    this.publicContent();
  },
};
</script>

<style scoped>
  /* #app{
    document-body-style-webkitTransform:  1; 
    document.body.style.msTransform =   scale;
    document.body.style.transform = scale; 
  }; */
  .v-btn {
    outline: none
  }

  .text{
    color: white
  };
</style>